<template>
  <div>
    <div class="WarningText">
      <div class="Text">
        预警中心
        <a href="javascript:;" class="SeeMore" @click="SeeMore">查看更多></a>
      </div>
    </div>
    <WarningList :WarningProp="WarningData" @WarnInfo="WarnInfo"></WarningList>
    <DialogFrom width="800px" title="查看详情" :dialogVisible="dialogVisibWarnInfo" @cancel="cancelWarnInfo" @dialogOK="dialogOKWarnInfo">
      <!-- RejectLicense证照驳回提醒 -->
      <div class="WarnInfoCss">
        <div v-if="WarnInfoList.Type == 'RejectLicense'" class="">
          <Reject :WarnInfoList="WarnInfoList" :WarnInfoData="WarnInfoData"></Reject>
        </div>
        <!-- WarningValiDate 近效期预警 -->
        <div v-if="WarnInfoList.Type == 'WarningValiDate'">
          <Effective :WarnInfoData="WarnInfoData" :WarnInfoList="WarnInfoList"></Effective>
        </div>
        <!-- AddLicense证照上传提醒 -->
        <div v-if="WarnInfoList.Type == 'AddLicense'">
          <div v-if="WarnInfoList.VoucherType == '营业执照'">
            <BusinessLicenseUpload :WarnInfoData="WarnInfoData"></BusinessLicenseUpload>
          </div>
          <div v-if="WarnInfoList.VoucherType == '医疗器械经营许可证'">
            <MedicalLicenseUpload :WarnInfoData="WarnInfoData"></MedicalLicenseUpload>
          </div>
          <div v-if="WarnInfoList.VoucherType == '第二类医疗器械备案凭证'">
            <MedicalDeviceLicenseUpload :WarnInfoData="WarnInfoData"></MedicalDeviceLicenseUpload>
          </div>
        </div>
        <!-- LicenseWarning证照过期预警 -->
        <div v-if="WarnInfoList.Type == 'LicenseWarning'">
          <div v-if="WarnInfoList.VoucherType == '营业执照'">
            <OverdueBusiness :WarnInfoData="WarnInfoData" :WarnInfoList="WarnInfoList"></OverdueBusiness>
          </div>
          <div v-if="WarnInfoList.VoucherType == '医疗器械经营许可证'">
            <OverdueMedical :WarnInfoData="WarnInfoData" :WarnInfoList="WarnInfoList"></OverdueMedical>
          </div>
          <div v-if="type == '第二类医疗器械备案凭证'">
            <OverdueMedicalDevice :WarnInfoData="WarnInfoData" :WarnInfoList="WarnInfoList"></OverdueMedicalDevice>
          </div>
        </div>
        <!-- WarningPrice发票底价预警 -->
        <div v-if="WarnInfoList.Type == 'WarningPrice'">
          <LowPriceWarning :WarnInfoData="WarnInfoData"></LowPriceWarning>
        </div>
        <!-- SaleBillCheckLabel  1、发票未通过校验。 2、发票驳回 3、发票待处理-->
        <div v-if="WarnInfoList.Type == 'SaleBillCheckLabel'">
          <Invoice :WarnInfoData="WarnInfoList"></Invoice>
        </div>
      </div>
    </DialogFrom>
  </div>
</template>

<script>
import WarningList from "./components/warningList.vue"
import DialogFrom from '@/components/dialog-from.vue'
import Reject from '../../../../EarlyWarningCcenter/components/components/reject'
import Effective from '../../../../EarlyWarningCcenter/components/components/effective'
import BusinessLicenseUpload from '../../../../EarlyWarningCcenter/components/components/BusinessLicenseUpload'
import MedicalLicenseUpload from '../../../../EarlyWarningCcenter/components/components/MedicalLicenseUpload'
import MedicalDeviceLicenseUpload from '../../../../EarlyWarningCcenter/components/components/MedicalDeviceLicenseUpload'
import OverdueBusiness from '../../../../EarlyWarningCcenter/components/components/OverdueBusiness'
import OverdueMedical from '../../../../EarlyWarningCcenter/components/components/OverdueMedical'
import OverdueMedicalDevice from '../../../../EarlyWarningCcenter/components/components/OverdueMedicalDevice'
import LowPriceWarning from '../../../../EarlyWarningCcenter/components/components/LowPriceWarning'
import Invoice from '../../../../EarlyWarningCcenter/components/components/invoice'
import {
  HomeRemindGetForWarning,
  HomeRemindGetWainingDetail
} from '@/api/channel'
export default {
  components: {
    WarningList,
    DialogFrom,
    Reject,
    Effective,
    BusinessLicenseUpload,
    MedicalLicenseUpload,
    MedicalDeviceLicenseUpload,
    OverdueBusiness,
    OverdueMedical,
    OverdueMedicalDevice,
    LowPriceWarning,
    Invoice
  },
  props: {
    WarningData: {
      type: Array
    }
  },
  data() {
    return {
      dialogVisibWarnInfo: false,
      type: '',
      WarnInfoList: {},
      WarnInfoData: null
    }
  },
  mounted() {
    // this.HomeRemindGetForWarning()
  },
  methods: {
    SeeMore() {
      this.$router.push({
        path: JSON.parse(localStorage.getItem("MenusData")).CusWebMenus.filter(item => item.NodeID == 64)[0].Path
      })
    },

    async HomeRemindGetWainingDetail(id) {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        data,
        message
      } = await HomeRemindGetWainingDetail({
        id: id
      })
      if (code == 0) {
        if (data) {
          this.dialogVisibWarnInfo = true
          this.WarnInfoData = data
        }
      } else {
        // this.$message.warning(message)
      }
      loading.close()
    },
    WarnInfo(item) {
      this.WarnInfoList = item
      this.HomeRemindGetWainingDetail(item.ID)
    },

    cancelWarnInfo() {
      this.dialogVisibWarnInfo = false
    },
    dialogOKWarnInfo() {
      this.dialogVisibWarnInfo = false
    },
  }
}
</script>

<style lang="less">
.WarningText {
  margin-top: 40px;
  height: 50px;
  //   border: 1px solid cornflowerblue;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  .Text {
    width: 340px;
    height: 155px;
    // border: 1px solid saddlebrown;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    line-height: 120px;
    overflow: hidden;
    position: relative;

    .SeeMore {
      height: 50%;
      width: 100%;
      display: block;
      font-weight: 400;
      //   border: 1px solid seagreen;
      color: #ffffff;
      font-size: 14px;
      text-decoration: none;
      position: absolute;
      top: -20px;
      transform: translate(0%, 65%);
    }
    .SeeMore::before {
      content: "各类证照、库存提醒、合同、资质到期预警    ";
      color: #ffffff;
    }
  }
}
</style>